export enum RESPONSE_TYPE {
  NETWORK_ERROR = 'Failed to fetch',
  NOT_FOUND = 404,
  UNPROCESSABLE_ENTITY = 422,
}
